import { Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type SectionHeaderProps = {
  title: string
  subtitle?: string
  rightChildren?: JSX.Element
  testId?: string
}

export const SectionHeader = ({
  title,
  subtitle,
  rightChildren,
  testId
}: SectionHeaderProps) => {
  return (
    <Wrapper data-testid={testId}>
      <LeftContainer>
        <Title level={2}>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </LeftContainer>
      {rightChildren}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 24px;
`

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const Subtitle = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`
